// extracted by mini-css-extract-plugin
export default {"container":"SelectAttachmentComponent__container___zADur","selectContainer":"SelectAttachmentComponent__selectContainer___IcZvN"};